import { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from '@flowshare/protocol';

/** Strip separators and case so a pasted code validates consistently. */
export function normalizeRoomCode(input: string): string {
  return input
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, ROOM_CODE_LENGTH);
}

export function isRoomCode(input: string): boolean {
  const code = normalizeRoomCode(input);
  if (code.length !== ROOM_CODE_LENGTH) return false;
  for (const char of code) {
    if (!ROOM_CODE_ALPHABET.includes(char)) return false;
  }
  return true;
}

/** Visual grouping used in the UI: "Q7M 2XR". */
export function formatRoomCode(input: string): string {
  const code = normalizeRoomCode(input);
  if (code.length <= 3) return code;
  return `${code.slice(0, 3)} ${code.slice(3)}`;
}

export function normalizeRoomCodeInput(input: string): string {
  return input
    .toUpperCase()
    .split('')
    .filter((char) => ROOM_CODE_ALPHABET.includes(char))
    .slice(0, ROOM_CODE_LENGTH)
    .join('');
}
